var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2875 10.7252C20.2875 10.0668 20.2292 9.44183 20.1292 8.8335H10.7125V12.5918H16.1042C15.8625 13.8252 15.1542 14.8668 14.1042 15.5752V18.0752H17.3209C19.2042 16.3335 20.2875 13.7668 20.2875 10.7252Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7126 20.4999C13.4126 20.4999 15.6709 19.5999 17.3209 18.0749L14.1043 15.5749C13.2043 16.1749 12.0626 16.5415 10.7126 16.5415C8.10427 16.5415 5.89593 14.7832 5.10427 12.4082H1.7876V14.9832C3.42926 18.2499 6.80427 20.4999 10.7126 20.4999Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10419 12.4083C4.89586 11.8083 4.78752 11.1666 4.78752 10.4999C4.78752 9.83327 4.90419 9.1916 5.10419 8.5916V6.0166H1.78752C1.10419 7.3666 0.712524 8.88327 0.712524 10.4999C0.712524 12.1166 1.10419 13.6333 1.78752 14.9833L5.10419 12.4083Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7126 4.45833C12.1876 4.45833 13.5043 4.96667 14.5459 5.95834L17.3959 3.10833C15.6709 1.49167 13.4126 0.5 10.7126 0.5C6.80427 0.5 3.42926 2.75 1.7876 6.01667L5.10427 8.59167C5.89593 6.21667 8.10426 4.45833 10.7126 4.45833Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.892bed736cfc1c60ecef975354fd1712.svg";
export { ForwardRef as ReactComponent };